
import { SNIPPET_CONVERSION, VENDORED_DEPENDENCY_DETECTION } from '../../../../../shared/featureFlags/flagNames';
import { useIsFeatureEnabled } from '../../../../helpers/features';

/**
 * Custom hook that returns whether snippet conversions are currently supported
 */
const useIsSnippetConversionSupported = (): boolean => {
  const isSnippetConversionEnabled = useIsFeatureEnabled(SNIPPET_CONVERSION);
  const isVendoredDependenciesEnabled = useIsFeatureEnabled(VENDORED_DEPENDENCY_DETECTION);
  return isVendoredDependenciesEnabled && isSnippetConversionEnabled;
};

export default useIsSnippetConversionSupported;
